import { Button, NonIdealState, Spinner } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';

import * as api from 'api';

import { useAppDispatch, useAppSelector } from 'hooks';
import { fetchClubs } from 'store/registration';
import styles from './styles.module.scss';

export default function ClubsTable() {
  const [addingNew, setAddingNew] = useState(false);
  const [newClubName, setNewClubName] = useState('');
  const [loading, setLoading] = useState(false);

  const clubs = useAppSelector((state) => state.registration.clubs) || [];

  const dispatch = useAppDispatch();

  async function reloadData() {
    setLoading(true);
    await dispatch(fetchClubs());
    setLoading(false);
  }

  useEffect(() => {
    reloadData();
  }, []);

  function resetInput() {
    setNewClubName('');
    setAddingNew(false);
  }

  async function saveNewClub() {
    try {
      setLoading(true);
      await api.addClub(newClubName);
      resetInput();
    } catch (err) {
      console.log('Failed to add club', err);
    }
    await reloadData();
    setLoading(false);
  }

  if (loading) {
    return <NonIdealState icon={<Spinner />} title="loading" />;
  }

  return (
    <div className={styles.clubs}>
      <div className={styles.headerRow}>Clubs</div>
      {clubs.map((club) => (
        <div key={club} className={styles.club}>
          {club}
        </div>
      ))}

      {addingNew ? (
        <>
          <input
            type="text"
            value={newClubName}
            onChange={(e) => setNewClubName(e.target.value)}
            className={styles.newClubInput}
          />
          <Button
            disabled={loading}
            text="Discard"
            onClick={() => {
              setAddingNew(false);
              setNewClubName('');
            }}
          />
          <Button
            text="Save"
            intent="success"
            disabled={!newClubName}
            onClick={saveNewClub}
            loading={loading}
          />
        </>
      ) : (
        <Button
          className={styles.addNewClub}
          intent="success"
          icon="plus"
          text="New club"
          onClick={() => setAddingNew(true)}
        />
      )}
    </div>
  );
}
